import angular from 'angular'
import CuratorSyncStatusComponent from './curator-sync-status.component'

export default angular
  .module('curatorSyncStatus', [])
  .component('curatorSyncStatus', CuratorSyncStatusComponent)
  .name
